import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { UserState } from 'src/app/store/user.state';
import { AppService } from '../../../services/app.service';
import { AsyncPipe } from '@angular/common';
import { NavigationService } from '../../../services/navigation.service';
import { Router } from '@angular/router';
import { ProductTourService } from '../../../services/product-tour.service';
import { FlagsState } from '../../../store/flags.state';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrl: './header-desktop.component.scss',
  imports: [TranslateModule, AsyncPipe],
})
export class HeaderDesktopComponent {
  get isMenuRoute(): boolean {
    const route = this.router.url.split('?')[0];

    return !['/home', '/explore', '/saved', '/dashboard'].includes(route) && !this.isSavedRoute && !this.isExploreRoute;
  }
  get currentRoute(): string {
    return this.router.url.split('?')[0];
  }

  get isSavedRoute(): boolean {
    const url = this.router.url.split('?')[0];

    return url === '/saved' || url === '/shelf/favorites' || url === '/shelf/continue-reading' || url === '/shelf/read-again';
  }

  get isExploreRoute(): boolean {
    const url = this.router.url.split('?')[0];

    return url === '/explore' || url.startsWith('/tip');
  }

  constructor(
    public userState: UserState,
    public appService: AppService,
    public productTourService: ProductTourService,
    public flagsState: FlagsState,
    public navigationService: NavigationService,
    private menuController: MenuController,
    private router: Router,
  ) {}

  toggleMenu(): void {
    if (!this.productTourService.productTourRunning$.value) {
      void this.menuController.toggle();
    }
  }

  goTo(route: string): void {
    if (!this.productTourService.productTourRunning$.value) {
      void this.navigationService.navigateRoot(route);
    }
  }

  async startHomeTour(): Promise<void> {
    if (this.router.url !== '/home') {
      await this.navigationService.navigateRoot('/home');
    }

    void this.productTourService.startTour();
  }
}
